import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Input, Card, notification, Slider, Dropdown } from 'antd';
import Marquee from 'react-fast-marquee';
import { SketchPicker } from 'react-color';
import { NotificationFilled } from "@ant-design/icons";
import axios from "axios";

const MarqeeEdit = (props) => {
    const [form] = Form.useForm();
    const [speed, set_speed] = useState(20);
    const [content, setContent] = useState(' ')
    const [pre_content, set_pre_content] = useState();
    const [font_size, set_font_size] = useState('1.2rem');
    const [background_color, set_background_color] = useState('#FFF3ED')
    const [background_color_dropdown, set_background_color_dropdown] = useState(false)
    const edit = () => {
        axios.patch("shopping/api/company_data", { data: [{ business_data_id: 4, string_name: `${background_color.r}, ${background_color.g}, ${background_color.b}, ${background_color.a}`, string_text: content, rate: speed }] })
            .then(response => {
                if (response.data.status === "success") {
                    notification.success({
                        message: '成功',
                        description: "編輯成功"
                    })
                    return true
                } else {
                    notification.error({
                        message: '錯誤',
                        description: "發生未知錯誤"
                    })
                    return false
                }
            })
    }

    const handleChange = (color) => {
        set_background_color(color.rgb)
    };
    useEffect(() => {
        axios.get("/shopping/api/company_data", { params: { business_data_id: 4 } })
            .then(response => {
                if (response.data) {
                    let tmp = response.data.find(tmp => tmp)
                    setContent(tmp.string_text)
                    let list = tmp.string_name.split(",")
                    set_background_color({ r: parseInt(list[0]), g: parseInt(list[1]), b: parseInt(list[2]), a: parseInt(list[3]) })
                    set_speed(tmp.rate)
                    form.setFieldValue("speed", tmp.rate)
                    form.setFieldValue("background_color", tmp.string_name)
                    form.setFieldValue("text", tmp.string_text)
                }
            })
    }, [])

    return <>
        <Row justify={'center'}>
            <Col span={24}>
                <Card style={{ background: '#F7F7F7', borderRadius: '15px', boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)', }}>
                    <Row justify={'left'}>
                        <Col span={23}>
                            <Marquee style={{ backgroundColor: `rgba(${background_color.r}, ${background_color.g}, ${background_color.b}, ${background_color.a})`, fontSize: font_size }} speed={speed}>
                                <NotificationFilled />{content}
                            </Marquee>
                        </Col>
                    </Row>
                    <Form style={{ width: '100%' }} form={form} onFinish={() => edit()}>
                        <Row justify={'center'} gutter={[20, 20]}>
                            <Col span={20}>
                                <Row justify={'space-around'}>
                                    <Col span={24}>
                                        <Form.Item
                                            label="速度"
                                            name="speed"
                                            rules={[
                                                {
                                                    required: false,
                                                    message: '請勿空白'
                                                },
                                            ]}
                                        >
                                            <Row align={'middle'} justify={'space-between'}>
                                                <Col span={1}>
                                                    慢
                                                </Col>
                                                <Col span={20}>
                                                    <Slider min={1} max={300} defaultValue={30} value={speed} onChange={e => set_speed(e)} />
                                                </Col>
                                                <Col span={1}>快</Col>
                                            </Row>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            label="背景顏色"
                                            name="background_color"
                                        >
                                            <Dropdown
                                                dropdownRender={() =>
                                                    <SketchPicker width={250} color={background_color} onChange={handleChange} />
                                                }
                                                trigger={["click"]}
                                                open={background_color_dropdown}
                                            >
                                                <Button style={{
                                                    width: '32px',
                                                    height: '1em',
                                                    borderRadius: '2px ',
                                                    borderColor: "#000000",
                                                    background: `rgba(${background_color.r}, ${background_color.g}, ${background_color.b}, ${background_color.a})`,
                                                }}
                                                    onClick={() => set_background_color_dropdown(pre => !pre)}
                                                />
                                            </Dropdown>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={20}>
                                <Form.Item
                                    label="內容"
                                    name="text"
                                    rules={[
                                        {
                                            required: false,
                                            message: '請勿空白'
                                        },
                                    ]}
                                >
                                    <Input.TextArea onChange={e => setContent(e.currentTarget.value)} />
                                </Form.Item>
                            </Col>
                            <Col span={20}>
                                <Form.Item style={{ width: '100%' }}>
                                    <Row gutter={[20, 20]} justify={'center'}>
                                        <Col>
                                            <Button type="primary" htmlType="submit">
                                                儲存
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Col>
        </Row>
    </>
}

export default MarqeeEdit;